import React, { useContext } from "react";
import logo from "../Assets/Images/Caduceus 512x512.gif";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ProfileContext } from "../context/ProfileContext";

const Footer = () => {
  const { handleConsultationClick } = useContext(ProfileContext);

  return (
    <div className="site_footer">
      <Container>
        <div className="footer-discrp">
          <h6>
            private & personalized healthcare experience at your fingertips
          </h6>
          <Link to="/consultation" className="main-btn" onClick={handleConsultationClick}>
            Start consultation
          </Link>
        </div>
        <div className="d-flex footer_logo_row">
          <div className="cm-line left"></div>
          <figure className="footer_logo">
            <a onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
              <img src={logo} alt="Example" className="img-fluid" />
            </a>
          </figure>
          <div className="cm-line right"></div>
        </div>
        <div className="copyright_sec d-flex flex-column gap-2 flex-sm-row align-items-center">
          <p>Copyright © 2025. All Rights Reserved.</p>

          <div className="footer-links d-flex align-items-center gap-5">
            <Link to="/privacy-policy">Privacy Policy</Link>

            <Link to="/terms-and-conditions">Terms & Conditions</Link>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Footer;
